import * as React from 'react';
const DifeseImmunitarieBasseIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M115.19 124.57a2.495 2.495 0 0 1 3.03-3.68c.9.37 1.47 1.22 1.53 2.13M112.98 115.69c-.52.15-1.09.13-1.63-.1a2.495 2.495 0 0 1-1.35-3.25 2.495 2.495 0 0 1 3.25-1.35"
      className="prefix__cls-1"
    />
    <path
      d="M89.46 135.51c-8.98-4.3-27.62-15.35-27.62-32.91V69.94c20.44.01 32.35-11.47 32.35-11.47s11.92 11.48 32.35 11.47v17.95"
      className="prefix__cls-2"
    />
    <path
      d="M85.66 121.26c-6.86-4.33-11.34-9.9-13.42-15.31-.53-1.37-.71-3.17-.71-4.9V78.51c14.32.01 22.67-8.03 22.67-8.03s8.35 8.05 22.67 8.03v5.85"
      className="prefix__cls-2"
    />
    <path
      d="M132.19 105.64c-.87.36-1.55.97-2.01 1.7-.54.9-1.24 1.6-2.03 2.14-1.18.81-2.78.54-3.72-.55-.45-.52-.94-1.01-1.47-1.45-1.12-.95-1.28-2.62-.41-3.8.52-.71 1.2-1.35 2.04-1.88.74-.46 1.35-1.14 1.71-2.01.91-2.19-.12-4.71-2.3-5.61s-4.68.14-5.59 2.34a4.35 4.35 0 0 0-.22 2.63c.25 1.02.26 2.02.08 2.96-.25 1.38-1.54 2.35-2.93 2.24-.67-.05-1.35-.06-2.03 0-1.41.1-2.72-.82-2.98-2.21-.18-.95-.18-1.95.08-2.98.2-.85.14-1.76-.22-2.63-.91-2.19-3.41-3.24-5.59-2.34s-3.21 3.41-2.3 5.61c.36.87.97 1.55 1.71 2.01.85.54 1.53 1.19 2.06 1.91.87 1.19.65 2.84-.47 3.8-.53.45-1.01.94-1.46 1.46-.96 1.12-2.63 1.27-3.82.41-.73-.53-1.38-1.2-1.89-2.05a4.2 4.2 0 0 0-2.01-1.7c-2.19-.91-4.71.12-5.61 2.3s.14 4.68 2.34 5.59c.87.36 1.78.41 2.63.21.97-.22 1.9-.24 2.77-.11 1.45.22 2.52 1.51 2.4 2.97-.06.68-.06 1.37-.01 2.06.1 1.43-.83 2.76-2.24 3.02-.94.17-1.93.17-2.95-.08-.85-.2-1.76-.14-2.63.22-2.19.91-3.24 3.41-2.34 5.59s3.41 3.21 5.61 2.3c.87-.36 1.55-.97 2.01-1.71.54-.85 1.19-1.53 1.91-2.06 1.19-.87 2.84-.65 3.8.47.45.53.94 1.01 1.46 1.46 1.12.96 1.27 2.63.41 3.82-.53.73-1.2 1.38-2.05 1.89a4.2 4.2 0 0 0-1.7 2.01c-.91 2.19.12 4.71 2.3 5.61s4.68-.14 5.59-2.34c.36-.87.41-1.78.21-2.63-.22-.96-.24-1.87-.12-2.74.21-1.47 1.53-2.55 3.01-2.43q1.05.09 2.13 0c1.48-.12 2.8.92 3.02 2.39.13.87.11 1.8-.11 2.77-.2.85-.15 1.76.21 2.63.91 2.19 3.41 3.24 5.59 2.34s3.21-3.41 2.3-5.61c-.36-.87-.97-1.55-1.7-2.01-.9-.54-1.6-1.24-2.14-2.03-.81-1.18-.54-2.78.55-3.72.52-.45 1.01-.94 1.45-1.47.95-1.12 2.62-1.28 3.8-.41.71.52 1.35 1.2 1.88 2.04.46.74 1.14 1.35 2.01 1.71 2.19.91 4.71-.12 5.61-2.3s-.14-4.68-2.34-5.59a4.35 4.35 0 0 0-2.63-.22c-.96.24-1.9.25-2.79.11-1.45-.23-2.52-1.53-2.41-2.99.05-.68.05-1.37 0-2.06-.12-1.48.89-2.8 2.35-3.02.88-.14 1.82-.12 2.81.11.85.2 1.76.15 2.63-.21 2.19-.91 3.24-3.41 2.34-5.59s-3.41-3.21-5.61-2.3ZM119.75 114.74l.04-.06M108.53 121.86l.03-.05"
      className="prefix__cls-1"
    />
  </svg>
);
export default DifeseImmunitarieBasseIcon;
